import { jwtDecode } from 'jwt-decode'

type Token = {
    exp: number
    iat: number
    userId: string
    userName?: string
}

export default class AuthService {
    public static getAuthToken(): string | null {
        return AuthService.getJwtFromCookie() || sessionStorage.getItem('accessToken')
    }

    public static getJwtFromCookie(): string | null {
        const tokenName = process.env.VUE_APP_ENV === 'master' ? 'JwtToken' : 'JwtTokenDev'
        const cookie = document.cookie.split('; ').find((c) => c.startsWith(`${tokenName}=`))
        return cookie ? cookie.split('=')[1] : null
    }

    public static setAuthTokens(accessToken: string, refreshToken: string): void {
        sessionStorage.setItem('accessToken', accessToken)
        sessionStorage.setItem('refreshToken', refreshToken)
    }

    public static coLogout() {
        window.location.href = `${process.env.VUE_APP_CO_BASE_URL}/Account/Logout`
    }

    public static logout(): void {
        sessionStorage.removeItem('accessToken')
        sessionStorage.removeItem('refreshToken')
    }

    public static getTokenExpirationDate(token: string) {
        const tokenDecoded: Token = jwtDecode<Token>(token)
        if (!tokenDecoded.exp) {
            return null
        }
        return tokenDecoded.exp
    }

    public static isAuth(): boolean {
        const token = AuthService.getAuthToken()
        if (token) {
            const expDate = this.getTokenExpirationDate(token)
            if (expDate !== null) {
                return expDate * 1000 > Date.now()
            }
        }
        return false
    }

    public static getUserId(): number | null {
        const token = AuthService.getAuthToken()
        if (token) {
            const tokenDecoded: Token = jwtDecode<Token>(token)
            return parseInt(tokenDecoded.userId)
        }
        return null
    }

    public static getUserName(): string | null {
        const token = AuthService.getAuthToken()
        if (token) {
            return jwtDecode<Token>(token).userName ?? null
        }
        return null
    }
}
